/** Layers whose popups should not open the memorial left panel. */
const PROJECT_POPUP_LAYERS = new Set(['project_centroids', 'cms_project_polygons']);

/** Memorial map tab layers (see map-preset-catalog overall-memorial_map). */
const MEMORIAL_MAP_LAYERS = new Set([
  'memorial',
  'coll_ped_fatal',
  'coll_bik_fatal',
  'coll_car_fatal',
]);

/**
 * Esri posts selectedFeature for every popup. Only memorial/collision features
 * should switch the left panel to the memorial tab.
 */
export function isMemorialMapSelectedFeature(data) {
  if (!data || !data.layer) {
    return false;
  }
  if (PROJECT_POPUP_LAYERS.has(data.layer)) {
    return false;
  }
  if (MEMORIAL_MAP_LAYERS.has(data.layer)) {
    return true;
  }
  const caseid = data.values && data.values.caseid;
  return caseid !== undefined && caseid !== null && String(caseid) !== '';
}
